import { upsertRegion } from '@dispatch/shared/services';
import { Region } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertRegion = (
  tenantId: string,
  regionId: string,
  onSuccess: () => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-taskGroup', regionId],
    async (data: Region[]) => upsertRegion(tenantId, data),
    {
      onSuccess,
      onSettled: () => {
        if (regionId) {
          client.invalidateQueries(['region', regionId]);
          client.invalidateQueries('region');
        }
      },
    }
  );

  return {
    upsertRegion: mutate,
    error,
    status,
  };
};
